/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	InvoiceEmailSettingsShowPathParams,
	InvoiceEmailSettingsShowResponse,
} from '../types/InvoiceEmailSettingsShow'

/**
 * GET /:organisation/invoice-email-settings
 * @see backend/nexus/modules/Billing/Http/Controllers/InvoiceEmailSettingsController.php InvoiceEmailSettingsController::show
 */
export async function invoiceEmailSettingsShow(
	organisation: InvoiceEmailSettingsShowPathParams['organisation'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<InvoiceEmailSettingsShowResponse>> {
	return axiosInstance.get(`/${organisation}/invoice-email-settings`, config)
}
